<template>
	<Accessible
		:name="name"
		:rootSelector="rootSelector"
		:tabOrder="tabOrder"
		:focusFirstItem="focusFirstItem"
		:data-ally-section="name"
		:trapped="trapped"
		:class="$attrs.class"
		ref="accessible"
		@esc="turnOffAccessibilityMode"
	>
		<slot />
	</Accessible>
</template>

<script>
import Accessible from './Accessible'

export default {
	name: 'AccessibleSection',
	components: { Accessible },
	props: {
		name: String,
		rootSelector: String,
		focusFirstItem: { type: Boolean, default: null },
		tabOrder: Array,
		trapped: Boolean,
	},

	methods: {
		turnOffAccessibilityMode() {
			this.accessibilityMode = false
			const borderelm = document.querySelector(
				'.accessibility-highlight-border'
			)
			borderelm.style.display = 'none'
		},
	},

	provide() {
		return { sectionName: this.name }
	},
}
</script>

<style lang="scss" scoped></style>
